module.exports = __webpack_public_path__ + "static/img/des3.2e615d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/buycardgetcoupon/des3.png
// module id = yWtm
// module chunks = 0